<template>
  <div>
    <!-- 轮播图-->
    <carousel-page :type='1'></carousel-page>
    <!-- 轮播图结束 -->
    <!-- 企业介绍 -->
    <introduce-page :type='"企业介绍"' :url='"static/assets/images/home/01.png"'></introduce-page>

    <!-- 企业介绍结束 -->
    <!-- 核心业务-->
    <section class="feature-area section-padding2"
      style='background-image: url("static/assets/images/service/bg.png");background-position: center center;background-size: cover;'>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>核心业务</h2>
              <p class='titleShadow'>CORE BUSINESS</p>
            </div>
          </div>
        </div>
        <div class="row flexJCenter" style='margin-top: -50px;'>
          <ul class='accordionWarp'>
            <li @click='checkoutCut(item.title)'
              :class='cut == item.title?"accordionItem accordionItemCut":"accordionItem"' v-for='(item,index) in hxList'
              :style='cut == item.title?"background-image: url(static/assets/images/home/hx1"+index+".png);":"background-image: url(static/assets/images/home/hx0"+index+".png);"'>
              <h3 class='accordionItemTitle'>{{item.title}}</h3>
              <div class='accordionItemAlt'>{{item.subTitle}}</div>
              <div class='accordionItemText' v-show='cut == item.title' v-html='item.content'></div>
            </li>
          </ul>

          <div class="row BIGaccordionWarp" style='justify-content: space-between;'>
            <div class="col-lg-3"  v-for='(item,index) in hxList' >
              <div :style='"background-image: url(static/assets/images/home/hx1"+index+".png);background-size:100% 100%;color: #fff;padding:40px;box-sizing: border-box;margin: 15px;"'>
              <h4 style='color: #fff;' class='accordionItemTitle'>{{item.title}}</h4>
              <div style='color: #fff;' class='accordionItemAlt'>{{item.subTitle}}</div>
              <div style='color: #fff;' class='accordionItemText' v-html='item.content'></div>
              </div>

            </div>


          </div>
        </div>
      </div>
    </section>
    <!-- 核心业务 结束 -->
    <!-- 企业优势 -->
    <section class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD' style='z-index: 100;position: relative;'>企业优势</h2>
              <p class='titleShadow'>ENTERPRISE ADVANTAGE</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <div class="col-lg-4 pRelative" style='margin-top: 10px;'>
            <img style='width: 100%;' src="static/assets/images/home/06.png" alt="理论教学">
          </div>
          <div class="col-lg-4 pRelative" style='margin-top: 10px;'>
            <img style='width: 100%;' src="static/assets/images/home/07.png" alt="现场教学">

          </div>
          <div class="col-lg-4 pRelative" style='margin-top: 10px;'>
            <img style='width: 100%;' src="static/assets/images/home/08.png" alt="体验教学">


          </div>

        </div>
      </div>
    </section>
    <!-- 企业优势结束 -->
    <!-- 合作伙伴 -->
    <section class="feature-area section-padding2"
      style='background-image: url("static/assets/images/home/bg.png");background-size: 100% 100%;'>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD' style='z-index: 100;position: relative;'>合作伙伴</h2>
              <p class='titleShadow'>COOPERATIVE PARTNER</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 pRelative">
            <div class='hezuohuobanWarp'>
              <img @click='imgClick(item.thirdUrl)' class='hezuohuobanItem' v-for='(item,index) in cooperation' :key='index' :src="item.titleImage" :alt="item.title">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 合作伙伴结束 -->
    <!-- 联系我们-->
    <contact-page></contact-page>

    <!-- 联系我们结束-->
  </div>
</template>

<script>
  import carouselPage from './module/carousel.vue'
  import introducePage from './module/introduce.vue'
  import contactPage from './module/contact.vue'
  export default {
    components: {
      carouselPage,
      introducePage,
      contactPage
    },
    data() {
      return {
        cut: '运营',
        hxList: [],
        cooperation:[]
      }
    },
    mounted() {
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/banner/list?isAdv=0',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.cooperation = res.data.data
        }
      })
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=核心业务',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.hxList = res.data.data
        }
      })
    },
    methods: {
      checkoutCut(name) {
        this.cut = name
      },
      imgClick(url){
          /* let path=window.location.protocol+'//'+url
          window.location.href=path */
         if(url){
           window.open(url, '_blank')
         }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?8c627dea